import $ from 'jquery';

class VideoPlayerAnalytics {
    constructor() {
        this.player = window.player;
        this.$window = $(window);
        this.durationCache = null;
        this.prerollEventsDone = null;
        this.playDone = null;
        this.userActionEventsDone = null;
    }

    trackGA(action, label) {
        let category = 'videoEmbed';
        // console.log('Category: ' + category + ' | Action: ' + action + ' | Label: ' + label);
        window.ga('send', 'event', category, action, label, null, {nonInteraction: 1});
        window.ga('rollup.send', 'event', category, action, label, null, {nonInteraction: 1});
    }

    handle(opt) {
        var player = opt.player;
        var self = this;    // eslint-disable-line consistent-this
        // User events

        if (opt.reset) {
            this.prerollEventsDone = null;
            this.playDone = null;
            this.userActionEventsDone = null;
        }

        /*
            A start occurs when the editorial content (not the pre-roll) begins to play.
            A play occurs when anything begins to play--editorial content OR preroll. ("play" should only fire once for each ad/content pair)
            A start and a play may occur at the same exact time if there is no preroll.
            A hit occurs when player loads
        */
        this.trackGA('hit', $('.vjs-video-title').text().trim());

        player.on('adstart', function () {
            var videoTitle = $('.vjs-video-title').text().trim();
            // A preroll is playing
            if (!self.prerollEventsDone || self.prerollEventsDone !== 'done') {
                self.trackGA('preroll', videoTitle);
                self.trackGA('play', videoTitle);
                this.playDone = 'done';
                self.prerollEventsDone = 'done';
            }
        });

        // Duration
        player.on('timeupdate', function () {
            var current = this.currentTime();
            var duration = this.duration();
            var percentViewed = Math.round(current / duration * 100);
            var videoTitle = $('.vjs-video-title').text().trim();

            // Not a preroll
            // if (!self.userActionEventsDone || self.userActionEventsDone !== 'done') {    // eslint-disable-line no-lonely-if
            if (this.ads.state === 'content-playback' && (!self.userActionEventsDone || self.userActionEventsDone !== 'done')) {
                // No preroll, editorial content plays
                self.trackGA('start', videoTitle);
                self.userActionEventsDone = 'done';

                if (!this.playDone) {
                    self.trackGA('play', videoTitle);
                }
            }

            // Play duration
            if ((percentViewed >= 25 && percentViewed < 50) && self.durationCache !== 25) {
                self.trackGA('25%', videoTitle);
                self.durationCache = 25;
            } else if ((percentViewed >= 50 && percentViewed < 75) && self.durationCache !== 50) {
                self.trackGA('50%', videoTitle);
                self.durationCache = 50;
            } else if ((percentViewed >= 75 && percentViewed < 100)  && self.durationCache !== 75) {
                self.trackGA('75%', videoTitle);
                self.durationCache = 75;
            } else if (percentViewed === 100 && self.durationCache !== 100) {
                self.trackGA('100%', videoTitle);
                self.durationCache = 100;
            }

        });
    }

    // Set Listeners
    on(opt) {
        this.handle(opt);
    }
}

export default new VideoPlayerAnalytics();
